import React from 'react';
import { UTLabel, UTCard } from '@widergy/energy-ui';
import { bool, func, string } from 'prop-types';

import { message } from 'utils/stringUtils';
import UTModal from 'app/components/UTModal';

import styles from './styles.module.scss';

const ModalPresentationRequirements = ({ isOpen, closeModal, alertFormOV, presentationRequirementsURL }) => {
  const cancelButton = {
    text: message('Commons:close'),
    onPress: closeModal
  };

  return (
    <UTModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      title={message(`Turns:confirmatedTurnModal`)}
      cancelButton={cancelButton}
    >
      <div className={styles.container}>
        <UTLabel className={styles.labelTitle}>{message('Turns:presentationRequirementsTitle')}</UTLabel>
        <UTLabel semibold className={styles.labelPresentationRequirements} secondary>
          {message('Turns:presentationRequirements', { presentationRequirementsURL })}
        </UTLabel>
        {alertFormOV && (
          <UTCard flat>
            <UTLabel className={styles.alertFormOV}>{message('Turns:modalFormAlertInfo')}</UTLabel>
          </UTCard>
        )}
      </div>
    </UTModal>
  );
};

ModalPresentationRequirements.propTypes = {
  isOpen: bool,
  closeModal: func,
  alertFormOV: bool,
  presentationRequirementsURL: string
};

export default ModalPresentationRequirements;
